import React, { type ReactNode } from "react";
import styles from "../FilterPanel.module.css";

export type SectionProps = {
  title?: string;
  children?: ReactNode;
  minHeight?: number;
  onReset?: () => void;
  plain?: boolean;
  isAccordion?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  isActive?: boolean;
};

const Section = ({
  title,
  children,
  minHeight,
  onReset,
  plain,
  isAccordion,
  isOpen,
  onToggle,
  isActive,
}: SectionProps) => {
  if (isAccordion) {
    return (
      <div className={styles.accordionSection}>
        <button
          className={`${styles.accordionSectionHeader} ${isOpen ? styles.accordionSectionHeaderOpen : ""}`}
          onClick={onToggle}
        >
          <span className={styles.accordionSectionTitle}>{title}</span>
          <svg
            className={`${styles.accordionSectionIcon} ${isOpen ? styles.accordionSectionIconOpen : ""}`}
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        {isOpen && <div className={styles.accordionSectionBody}>{children}</div>}
      </div>
    );
  }

  return (
    <div
      className={`${plain ? styles.sectionRootPlain : styles.sectionRoot} ${isActive ? styles.sectionRootActive : ""}`}
    >
      <div className={styles.sectionHeader}>
        {title ? <div className={styles.sectionTitle}>{title}</div> : null}
        {onReset ? (
          <button type="button" className={styles.sectionReset} onClick={onReset}>
            Reset
          </button>
        ) : null}
      </div>
      <div
        className={title ? styles.sectionBodyWithTitle : styles.sectionBody}
        style={minHeight ? { minHeight } : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default Section;
